import { forwardRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { InputProps, TextareaProps } from './types';

export type AutoGrowTextareaProps = TextareaProps &
  InputProps<'text'> & {
    maxRows?: number;
    minRows?: number;
  };

export const AutoGrowTextarea = forwardRef<HTMLTextAreaElement, AutoGrowTextareaProps>(
  ({ maxRows = 10, minRows = 2, spellCheck = true, ...rest }, ref) => {
    //@ts-ignore -> we are using HTMLInput props and not HTMLTextArea, need to create
    // a new entry in FieldConfig for type = "textarea"
    return <TextareaAutosize {...rest} ref={ref} minRows={minRows} maxRows={maxRows} spellCheck={spellCheck} />;
  }
);
AutoGrowTextarea.displayName = 'AutoGrowTextarea';
